import { useLocation } from 'react-router'

export const useEditMode = () => {
  const location = useLocation()

  // TODO: details page currently does not count as edit mode as it shows
  // as there is logic in BottomActionsBar speciyfing the button based on edit mode
  const isEditDetailsPath = location.pathname.endsWith('/details')
  const isEditPath = location.pathname.startsWith('/edit/')
  const isDirectPath = location.pathname.startsWith('/direct/')

  if (isDirectPath || isEditDetailsPath) {
    return false
  } else if (isEditPath) {
    return true
  }

  return null
}
